<template>
  <div class="flex-grow-1 d-flex flex-column">
    <work-order-process
      v-if="orderInfo"
      style="padding:1rem;margin-bottom:1rem"
      class="selector-container section-container" :class="{'dark':skinType}"
      v-bind:processIndex.sync="stepIndex"
      :processList="orderInfo.ProcessRecords"
    ></work-order-process>
    <div class="section-container none-height flex-grow-1 d-flex "  :class="{'dark':skinType}">
      <div class="section-container none-height flex-grow-1 d-flex flex-column work-steps align-items-stretch"
          :class="{'dark':skinType}"
          style="padding:2rem;margin-bottom:1rem">
          <section-title title="基本信息">
          </section-title>
        <el-row
        style="padding: 2rem"
          :gutter="24"
          class="d-flex align-items-center justify-content-between flex-wrap"
        >
          <el-col :span="12" class="d-flex justify-content-between"
            style="padding-top:10px;">
            <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
              工单名称:
            </div>
            <div
              class="brief-info-content none-width flex-grow-1"
              style="text-align: right"
              :class="{'dark':skinType}"
            >
            {{ orderInfo.F_ProcessName }}
            </div>
          </el-col>
          <el-col :span="12" class="d-flex justify-content-between"
            style="padding-top:10px;">
            <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
              创建时间:
            </div>
            <div
              class="brief-info-content none-width flex-grow-1"
              style="text-align: right"
              :class="{'dark':skinType}"
            >
              {{ orderInfo.F_CreateDate }}
            </div>
          </el-col>
          <el-col :span="12" class="d-flex justify-content-between"
            style="padding-top:10px;">
            <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
              创建者:
            </div>
            <div
              class="brief-info-content none-width flex-grow-1"
              style="text-align: right"
              :class="{'dark':skinType}"
            >
              {{ orderInfo.F_CreateUserName }}
            </div>
          </el-col>
          <el-col :span="12" class="d-flex justify-content-between"
            style="padding-top:10px;">
            <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
              工单类型:
            </div>
            <div
              class="brief-info-content none-width flex-grow-1"
              style="text-align: right"
              :class="{'dark':skinType}"
            >
              {{ orderInfo.F_SchemeName }}
            </div>
          </el-col>
          <el-col :span="12" class="d-flex justify-content-between"
            style="padding-top:10px;">
            <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
              工单描述:
            </div>
            <div
              class="brief-info-content none-width flex-grow-1"
              style="text-align: right"
              :class="{'dark':skinType}"
            >
              {{ orderInfo.F_Description }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="section-container flex-grow-1 d-flex flex-column work-steps align-items-stretch"
          :class="{'dark':skinType}"
          style="padding:2rem;margin-bottom:1rem">
        <div class="d-flex align-items-center justify-content-between">
          <section-title title="流程详情"></section-title>
        </div>
        <work-step :stepInfo="stepInfo" class="flex-grow-1" style="padding: 2rem"/>
      </div>
    </div>
  </div>
</template>
<script>
import WorkStep from '@/components/equipment-operational/components/work-detail/work-step.vue';
import SectionTitle from '@/components/utils/section-title.vue';
import WorkOrderProcess from '@/components/equipment-operational/components/work-detail/work-order-process.vue';
import { GetProcessDetailsNew } from '@/api/workorder-management/workorder-management';

export default {
  name: 'work-detail',
  components: {
    WorkStep,
    SectionTitle,
    WorkOrderProcess,
  },
  data() {
    return {
      processId: '',
      // 当前工单步骤
      stepInfo: {},
      // 工单信息
      orderInfo: {},
      // 步骤顺序
      stepIndex: 0,
      lastActiveStepIndex: 0,
    };
  },
  created() {
    this.getIds();
    this.requestWorkDetail();
  },
  watch: {
    stepIndex(newVal) {
      this.stepInfo = this.orderInfo.ProcessRecords[newVal];
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    getIds() {
      this.processId = this.$route.params.id;
    },
    manageProcess() {

    },
    requestWorkDetail() {
      GetProcessDetailsNew({
        ProcessId: this.processId,
        WRID: '',
      }).then((res) => {
        [this.orderInfo] = res;
        const { stepIndex } = this.getInitialStepInfo(res[0]);
        this.lastActiveStepIndex = stepIndex;
        if (this.stepIndex === stepIndex) {
          this.stepInfo = this.orderInfo.ProcessRecords[this.stepIndex];
        } else {
          this.stepIndex = stepIndex;
        }
      });
    },
    // 获取初始步骤信息
    getInitialStepInfo(orderInfo) {
      const stepIndex = orderInfo.ProcessRecords.findIndex(
        (process, index, list) => process.F_CreateDate && (!list[index] || !list[index + 1]),
      );
      const stepInfo = orderInfo.ProcessRecords[stepIndex];
      return {
        stepIndex,
        stepInfo,
      };
    },
  },
};
</script>
<style scoped>
.selector-container{
  padding: 1rem;
  margin-bottom: 1rem;
}
.brief-info-container {
  padding: 1rem;
  font-size:1.2rem
}
.brief-info-row+.brief-info-row{
  margin-top: 0.5rem;
  /* background-color: red; */
  /* color: blue; */
}
.brief-info{
  padding:0rem 1.0rem 0.6rem;
}
.brief-info-title {
  color: #999999;
}
.brief-info-title.dark {
    color:white;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  /* color: red; */
  /* color: #999999; */
}

.brief-info-content {
  color: #111111;
}
.brief-info-content.dark{
  font-size: 15px;
  text-align: center;
  margin: auto;
  color: #EEEEEE;
}
.detail-info{
  padding: 1rem;
}
.elRow.dark .el-row{
  color: white;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  text-align: left;
}
.elRow .el-row{
  color: #999999;
  line-height: 40px;
  text-align: left;
}
</style>
